// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__2eeMb","icon":"style_icon__1WRah","flag":"style_flag__Fvp74","menuIcon":"style_menuIcon__3wjOG"};